import React from 'react';
import { Button } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

const EditProfileButton = ({ onClick, disabled }) => (
  <Button
    variant="contained"
    color="primary"
    onClick={onClick}
    disabled={disabled}
    startIcon={<EditIcon />}
    sx={{ textTransform: 'none' }}
  >
    Edit Profile
  </Button>
);

export default EditProfileButton;
